import React, { useEffect, useState } from "react";
import feather from "feather-icons";
import { Link, useLocation } from "react-router-dom";

const Home = () => {
  const location = useLocation();
  const [alertMsg, setAlertMsg] = useState("");

  // === INITIALISATION FEATHER ICONS ===
  useEffect(() => {
    setTimeout(() => feather.replace(), 200);
  }, []);

  // === MESSAGE CONTEXTUEL SELON LA REDIRECTION ===
  useEffect(() => {
    if (location.state?.reason) {
      switch (location.state.reason) {
        case "wallet_not_connected":
          setAlertMsg("🦊 Please connect your wallet to access the Dashboard.");
          break;
        case "wrong_network":
          setAlertMsg("⚠️ Please switch to the Polygon Mainnet network.");
          break;
        case "not_admin":
          setAlertMsg("⛔ Admin access only. Redirected to Dashboard.");
          break;
        default:
          setAlertMsg("");
      }

      // Nettoyage automatique après 6 secondes
      const timer = setTimeout(() => setAlertMsg(""), 6000);
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  return (
    <div className="relative z-10 min-h-screen text-white px-4 md:px-12 py-24 backdrop-blur-sm">
      {/* === Alerte dynamique === */}
      {alertMsg && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 bg-gray-900 border border-neonPink/50 text-neonPink px-6 py-3 rounded-lg shadow-lg animate-pulse text-center max-w-md">
          {alertMsg}
        </div>
      )}

      {/* === Hero Section === */}
      <section className="text-center mb-24">
        <h1 className="text-6xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-neonPink via-neonPurple to-neonBlue animate-pulse">
          NEXORA – Empowering the Next Generation
        </h1>
        <p className="text-xl max-w-3xl mx-auto mb-8">
          Education, Culture, Health, Civic Life – All on the Blockchain.
        </p>
        <Link
          to="/buy"
          className="inline-block px-8 py-4 bg-gradient-to-r from-neonPurple to-neonPink rounded-lg font-bold text-lg hover:opacity-90 transition-all animate-bounce"
        >
          Buy NEXORA
        </Link>
      </section>

      {/* === Vision Section === */}
      <section className="mb-24">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold mb-6">Our Vision</h2>
            <p className="text-lg mb-6">
              NEXORA is building a decentralized ecosystem that empowers young
              people through blockchain technology in education, culture, health,
              and civic engagement.
            </p>
            <p className="text-lg mb-6">
              We're creating tools and platforms that give the next generation
              control over their digital future and real-world impact.
            </p>
            <Link
              to="/about"
              className="inline-block px-6 py-3 border border-neonBlue rounded-lg hover:bg-neonBlue hover:text-white transition-colors"
            >
              Learn More About Our Mission
            </Link>
          </div>

          {/* Vision Cards */}
          <div className="grid grid-cols-2 gap-4">
            {[
              {
                icon: "book",
                color: "neonPink",
                title: "Education",
                text: "Blockchain-powered learning with verifiable credentials.",
              },
              {
                icon: "music",
                color: "neonBlue",
                title: "Culture",
                text: "Supporting emerging artists through decentralized funding.",
              },
              {
                icon: "heart",
                color: "neonPurple",
                title: "Health",
                text: "Mental and physical wellbeing initiatives for youth.",
              },
              {
                icon: "users",
                color: "neonPink",
                title: "Civic Life",
                text: "DAO-powered advocacy for youth representation.",
              },
            ].map(({ icon, color, title, text }) => (
              <div
                key={title}
                className={`bg-gray-900 bg-opacity-70 backdrop-blur-lg rounded-xl p-6 border border-${color}/40 text-center`}
              >
                <div className={`text-${color} mb-4`}>
                  <i data-feather={icon} className="w-10 h-10 mx-auto"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">{title}</h3>
                <p className="text-gray-300">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* === Stats Section === */}
      <section className="bg-gray-900 bg-opacity-70 backdrop-blur-lg rounded-xl p-8 mb-24 border border-neonBlue/40">
        <h2 className="text-3xl font-bold mb-8 text-center">
          NEXORA By The Numbers
        </h2>
        <div className="grid md:grid-cols-4 gap-8 text-center">
          {[
            ["1B", "Total Supply"],
            ["$0.0005", "Initial Price"],
            ["$0.5M", "Initial Market Cap"],
            ["30%", "Public Sale Allocation"],
          ].map(([value, label]) => (
            <div key={label}>
              <div className="text-5xl font-bold text-neonPink mb-2">
                {value}
              </div>
              <p className="text-gray-400">{label}</p>
            </div>
          ))}
        </div>
        <div className="mt-8 text-center">
          <Link
            to="/tokenomics"
            className="inline-block px-6 py-3 border border-neonPurple rounded-lg hover:bg-neonPurple hover:text-white transition-colors"
          >
            View Full Tokenomics
          </Link>
        </div>
      </section>

      {/* === CTA Section === */}
      <section className="text-center">
        <h2 className="text-4xl font-bold mb-6">Join the NEXORA Movement</h2>
        <p className="text-xl max-w-3xl mx-auto mb-8">
          Be part of the blockchain revolution that’s empowering the next
          generation.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/tokenomics"
            className="px-8 py-4 bg-gradient-to-r from-neonPurple to-neonPink rounded-lg font-bold hover:opacity-90 transition-all"
          >
            Learn About Token
          </Link>
          <Link
            to="/roadmap"
            className="px-8 py-4 bg-gray-900 rounded-lg border border-neonBlue hover:bg-neonBlue hover:text-white transition-colors font-bold"
          >
            View Our Roadmap
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
